import axios from 'axios';
import config from '@/config/config';
import { message } from 'ant-design-vue';
import router from '../router';
// 创建axios实例
const service = axios.create({
  baseURL: config.config+'/api.php/', // API的base_url
  timeout: 5000 ,// 请求超时时间
  headers:{
    // 'content-type': 'application/x-www-form-urlencoded',
    'content-type': 'application/json',
    'city-id':localStorage.getItem('cityId')||0,
    // token:"sf",  
    token:localStorage.getItem('token')||''
  }
});
 
// 请求拦截器
// service.interceptors.request.use(
//   config => {
//     // 可以在这里添加请求头等信息
//     config.headers['Content-Type']="application/x-www-form-urlencoded"
//     config.headers['Authorization'] = `sf`;
//     return config;
//   },
//   error => {
//     // 请求错误处理
//     return Promise.reject(error);
//   }
// );
 
// 响应拦截器
service.interceptors.response.use(
   response => {
      // return response.data;
        const { code, data, msg } = response.data;
        // console.log(code, data, msg);
        if (code === 200) {
          return response.data;  
      } else if (code === 402 ) {
          message.warn('登录已过期请重新登录').then(()=>{
                router.push('/login')
            })
            return null;
        }  else {
          // message.warn(msg)
          message.warn(msg)
          // message.config({
          //   prefixCls: 'my-message'
          // })
          return null;
        }
      },
   error => {
      return Promise.reject(error);
   }
);
 
// 封装get方法
export function get(url, params) {
  return service.get(url, {
    params: params
  });
} 
 
// 封装post方法
export function post(url, data) { 
   return service.post(url, data);
}
  